module.exports = __webpack_public_path__ + "img/image 10.49bb39dc.png";